import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';

import unfoldIcon from '../assets/icon/jiantou_geren_icon.png';
import foldIcon from '../assets/icon/heijiantou_geren_icon.png';

const Container = styled(BoxDiv)`
  padding: 41px;
`;

const PhotoContainer = styled.img`
  width: 100%;
  border-radius: 14px 14px 0 0;
  border: 1px solid #dfdfdf;
  border-bottom: none;
  display: block;
`;

const Card = styled.div`
  border-radius: 0 0 14px 14px;
  border: 1px solid #dfdfdf;
  padding: 40px 0;
  & > * {
    vertical-align: middle;
  }
`;

const FoldedCard = styled(Card)`
  padding-bottom: 20px;
`;

const Row = styled.div`
  margin: 0;
  margin-bottom: 30px;
  width: 100%;
  
  &:last-child {
    margin: 0;
  }
`;

const ItemName = styled.span`
  display: inline-block;
  width: 115px;
  font-size: 26px;
  line-height: 1;
  text-align: right;
  color: #666666;
`;

const ItemValue = styled(ItemName)`
  text-align: left;
  width: auto;
  color: #fc855b;
`;

const ScreenOnly = styled.div`
  @media print {
    display: none;
  }
`;

const PrintOnly = styled.div`
  @media screen {
    display: none;
  }
`;

const Unfold = styled(ScreenOnly)`
  margin: 0;
  margin-top: 28px;
  text-align: center;
`;

const Fold = styled(ScreenOnly)`
  margin: 27px auto 0 auto;
  text-align: center;
  width: 100%;
  font-size: 25px;
  color: #666;
`;

class Result extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folded: this.props && !!this.props.renderMore
    };
    this._onUnfold = this._onUnfold.bind(this);
    this._onFold = this._onFold.bind(this);
  }

  _onUnfold() {
    this.setState({ folded: false });
  }

  _onFold() {
    this.setState({ folded: true });
    if (this.containerRef) {
      const { top } = this.containerRef.getBoundingClientRect();

      window.scroll(0, window.scrollY + top);
    }
  }

  renderUnfoldAnchor() {
    if (!this.state.folded) return null;
    return (
      <Unfold onClick={this._onUnfold}>
        <ItemName style={{ margin: 0, fontSize: '25px', minWidth: 0 }}>
          查看详情
        </ItemName>
        <img
          src={unfoldIcon}
          alt='unfold'
          style={{
            height: '18px',
            marginLeft: '5px',
          }}
        />
      </Unfold>
    );
  }

  renderFoldAnchor() {
    if (this.state.folded || !this.props.renderMore) return null;
    return (
      <Fold onClick={this._onFold}>
        收起全部
        <img
          src={foldIcon}
          alt='fold'
          style={{
            height: '15px',
            marginLeft: '10px',
          }}
        />
      </Fold>
    );
  }

  renderMore() {
    return [
      (this.state.folded || !this.props.renderMore) ? null :
      <ScreenOnly style={{ width: '100%', margin: 0 }} key='screen'>
        {this.props.renderMore()}
      </ScreenOnly>,
      <PrintOnly style={{ width: '100%', margin: 0 }} key='print'>
        {this.props.renderMore()}
      </PrintOnly>
    ];
  }

  render() {
    const {
      keys, keyNames, values, photo
    } = this.props;
    const CardType = this.state.folded ? FoldedCard : Card;
    return (
      <Container innerRef={r => this.containerRef = r}>
        <PhotoContainer src={photo} />
        <CardType>
          {
            keys.map(k => (
              <Row key={k}>
                <ItemName>{keyNames[k] !== undefined ? `${keyNames[k]}： ` : null}</ItemName>
                <ItemValue>{values[k] !== undefined ? values[k] : null}</ItemValue>
              </Row>
            ))
          }
          {this.renderUnfoldAnchor()}
        </CardType>
        {this.renderMore()}
        {this.renderFoldAnchor()}
      </Container>
    );
  }
}

Result.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  keyNames: PropTypes.object,
  values: PropTypes.object,
  renderMore: PropTypes.func,
  photo: PropTypes.string.isRequired,
};

Result.defaultProps = {
  keyNames: {},
  values: {},
  renderMore: null,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/result.jsx